import {gql} from "@irati/utils/gql"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import RecognitionFeedReaction from "../../services/fragments/RecognitionFeedReaction"

const fragment = gql`
  fragment Comment on RecognitionFeedComment {
    uuid
    createdAt
    updatedAt
    createdBy {
      ...partialUser
    }
    message
    moderated
    archived
    reactions {
      results {
        ...reactionFields
      }
    }
  }
  ${RecognitionFeedReaction}
  ${partialUser}
`
export default fragment
